// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statusSend{
    color:green;
    font-weight: bold;
}
.statusDelivered{
    color:green;
    font-weight: bold;
}

.statusPending{
    color:red;
    /* font-weight: bold; */
}

.statusRejected{
    color:red;
    /* font-weight: bold; */
}

.statusNotRead{
    color:red;
    /* font-weight: bold; */
}`, "",{"version":3,"sources":["webpack://./src/pages/ReferenceDraftReports.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,uBAAuB;AAC3B","sourcesContent":[".statusSend{\n    color:green;\n    font-weight: bold;\n}\n.statusDelivered{\n    color:green;\n    font-weight: bold;\n}\n\n.statusPending{\n    color:red;\n    /* font-weight: bold; */\n}\n\n.statusRejected{\n    color:red;\n    /* font-weight: bold; */\n}\n\n.statusNotRead{\n    color:red;\n    /* font-weight: bold; */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
